import { render } from "./claim-rejected-reason-card.vue?vue&type=template&id=33513949&ts=true"
import script from "./claim-rejected-reason-card.vue?vue&type=script&lang=ts"
export * from "./claim-rejected-reason-card.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__